import React, { useEffect, useState } from 'react';
import './BetHistoryPage.css';
import { authService } from '../services/authService';

const AccountStatement = () => {
  const [loading, setLoading] = useState(true);
  const [records, setRecords] = useState([]);
  const [wallet, setWallet] = useState('');
  const [error, setError] = useState('');

  const token = authService.getToken();

  useEffect(() => {
    const fetchAccountStatement = async () => {
      if (!token) {
        setError('Session expired. Please login again.');
        setLoading(false);
        return;
      }

      try {
        const res = await fetch(
          'https://playinbyd.com/api/api-wallet-transaction-history',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              app_key: 'SgRTXsywVmWteEBLlYWecwgbDiHwlh',
              env_type: 'Prod',
              unique_jwt_token: token
            })
          }
        );

        const data = await res.json();
        console.log('Account Statement API:', data);

        if (data?.success) {
          setRecords(data.transaction_history || []);
          setWallet(data.wallet_amt || '0');
        } else {
          setRecords([]);
        }
      } catch (err) {
        console.error(err);
        setError('Failed to load account statement');
      } finally {
        setLoading(false);
      }
    };

    fetchAccountStatement();
  }, [token]);

  const getTxnType = (type) => {
    return type === '1' ? 'Credit' : 'Debit';
  };

  const getTxnClass = (type) => {
    return type === '1' ? 'status-open' : 'status-pending';
  };

  return (
    <div className="bet-history-page">
      {/* HEADER */}
      <div className="page-header">
        <div>
          <h1 className="page-title">Account Statement</h1>
          <p className="page-subtitle">
            Wallet transaction history
          </p>
        </div>

        <div className="user-info-card">
          <div className="user-details">
            <div className="user-name">
              Wallet Balance: ₹{wallet}
            </div>
          </div>
        </div>
      </div>

      {/* CONTENT */}
      <div className="content-card">
        {loading ? (
          <div className="loading-state">
            <div className="spinner"></div>
            <p>Loading account statement...</p>
          </div>
        ) : error ? (
          <div className="empty-state">
            <div className="empty-icon">⚠️</div>
            <p>{error}</p>
          </div>
        ) : records.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">📄</div>
            <h3>No Transactions Found</h3>
            <p>No wallet transactions available.</p>
          </div>
        ) : (
          <>
            <div className="table-container">
              <table className="bet-history-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>TYPE</th>
                    <th>AMOUNT</th>
                    <th>NOTE</th>
                    <th>PREV BAL</th>
                    <th>CURRENT BAL</th>
                    <th>DATE</th>
                  </tr>
                </thead>
                <tbody>
                  {records.map((row, index) => (
                    <tr key={row._id || index}>
                      <td className="serial-number">{index + 1}</td>

                      <td>
                        <span
                          className={`status-badge ${getTxnClass(
                            row.transaction_type
                          )}`}
                        >
                          {getTxnType(row.transaction_type)}
                        </span>
                      </td>

                      <td className="points-cell">
                        <span className="points-value">
                          ₹{row.amount}
                        </span>
                      </td>

                      <td>{row.transaction_note || '-'}</td>

                      <td>₹{row.previous_balance}</td>

                      <td>₹{row.updated_balance}</td>

                      <td className="date-time-cell">
                        {row.insert_date}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="table-footer">
              <div className="footer-info">
                Showing <strong>{records.length}</strong> records
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default AccountStatement;
